import { Controller } from "@hotwired/stimulus";

// Live DOI-anatomy preview for the ConfTool import + volume forms. Shows how the
// Volume label and the series' "Label for DOI" fill the DOI segments. The start
// page follows pagination; the year is minted at volume publish, so until then the
// DOI carries the "XXXX" placeholder. On the import form the prefix + series label
// come from the selected publication series' <option> data attributes; on the
// volume form they are passed as static values.
export default class extends Controller {
  static targets = [
    "series", "volumeLabel", "contextSelect",
    "prefixOut", "seriesOut", "volumeOut", "provisional", "permanent",
  ];
  static values = { prefix: String, fallbackSeries: String, year: String };

  connect() {
    this.update();
  }

  update() {
    if (this.hasContextSelectTarget) this.readContext();

    const prefix = this.prefixValue || "‹prefix›";
    const series =
      (this.hasSeriesTarget && this.seriesTarget.value.trim()) ||
      this.fallbackSeriesValue ||
      "‹series›";
    const volume =
      (this.hasVolumeLabelTarget && this.volumeLabelTarget.value.trim()) ||
      "‹volume label›";
    const year = this.yearValue || "‹year›";

    if (this.hasPrefixOutTarget) this.prefixOutTarget.textContent = prefix;
    if (this.hasSeriesOutTarget) this.seriesOutTarget.textContent = series;
    if (this.hasVolumeOutTarget) this.volumeOutTarget.textContent = volume;

    const join = (parts) => parts.filter(Boolean).join("-");
    if (this.hasProvisionalTarget) {
      this.provisionalTarget.textContent = `${prefix}/${join([series, volume, "‹page›", "XXXX"])}`;
    }
    if (this.hasPermanentTarget) {
      this.permanentTarget.textContent = `${prefix}/${join([series, volume, "‹page›", year])}`;
    }
  }

  // Pull the prefix + series label (the series' "Label for DOI", falling back to
  // its url_path server-side) from the selected series option.
  readContext() {
    const option = this.contextSelectTarget.selectedOptions[0];
    if (!option) return;
    this.prefixValue = option.dataset.doiPrefix || "";
    this.fallbackSeriesValue = option.dataset.seriesLabel || "";
  }
}
